import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleApplyPenaltyFee } from '../../redux/modules/registration';
import renewalPenaltyTotal from '../../selectors/renewalPenaltyTotal.selector';
import TextInput from '../../components/TextInput';

class PenaltyFee extends Component {
  render() {
    const { penaltyFee, applyPenaltyFee } = this.props;
    return (
      <div className="Row Registration-plateFeeRow">
        <TextInput tabIndex="-1" className="Row-total" data-id="penaltyTotal" id="Rsub2" tooltip="Plate Issue Fees Total including all County, if applicable" value={applyPenaltyFee ? penaltyFee : '0.00'} readOnly />
        <input className="no-print" id="Penaltybox" data-tooltip="Check to apply penalty fees for this vehicle." type="checkbox" checked={applyPenaltyFee && Number(penaltyFee) > 0} onChange={this.props.toggleApplyPenaltyFee} />
        <label className="no-print" htmlFor="Penaltybox">Apply renewal penalty amount</label>
        <b className="print-label print-only">Renewal Penalty</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    penaltyFee: renewalPenaltyTotal(state),
    applyPenaltyFee: state.registration.applyPenaltyFee,
  };
};

export default connect(mapStateToProps, { toggleApplyPenaltyFee })(PenaltyFee);
